// French formatting helpers
export const nf = new Intl.NumberFormat('fr-FR');
export const nf1 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
export const nf2 = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function fmtInt(v) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return nf.format(Math.round(v));
}
export function fmtNum(v, d = 1) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
}
export function fmtPct(v, d = 1) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: d }).format(v * 100)}\u202f%`;
}
export function fmtEur(v, d = 2) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }).format(v)}\u202f€`;
}
export function fmtSignedPct(v, d = 1) {
  if (v === null || v === undefined || isNaN(v)) return null;
  const s = v >= 0 ? '+' : '';
  return `${s}${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: d }).format(v * 100)}\u202f%`;
}
export function fmtDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return iso; }
}
export function fmtDateTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return iso; }
}
